import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../store/actions/index';

class Consent extends Component {
    componentDidMount() {
        this.props.onGetConsentsPdf(this.props.match.url);
    }

    render() {
        return null;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGetConsentsPdf: path => dispatch(actions.onGetConsentsPdf(path)),
    };
};

export default withRouter(connect(null, mapDispatchToProps)(Consent));
